//common
export var WHITE = 'common.white';
//error
export var ERROR25 = 'error.25';
export var ERROR50 = 'error.50';
export var ERROR100 = 'error.100';
export var ERROR200 = 'error.200';
export var ERROR300 = 'error.300';
export var ERROR400 = 'error.400';
export var ERROR500 = 'error.500';
export var ERROR600 = 'error.600';
export var ERROR700 = 'error.700';
export var ERROR800 = 'error.800';
export var ERROR900 = 'error.900';
export var ERROR950 = 'error.950';
//gray
export var GRAY25 = 'gray.25';
export var GRAY50 = 'gray.50';
export var GRAY100 = 'gray.100';
export var GRAY200 = 'gray.200';
export var GRAY300 = 'gray.300';
export var GRAY400 = 'gray.400';
export var GRAY500 = 'gray.500';
export var GRAY600 = 'gray.600';
export var GRAY700 = 'gray.700';
export var GRAY800 = 'gray.800';
export var GRAY900 = 'gray.900';
export var GRAY950 = 'gray.950';
//primary
export var PRIMARY25 = 'primary.25';
export var PRIMARY50 = 'primary.50';
export var PRIMARY100 = 'primary.100';
export var PRIMARY200 = 'primary.200';
export var PRIMARY300 = 'primary.300';
export var PRIMARY500 = 'primary.500';
export var PRIMARY600 = 'primary.600';
export var PRIMARY700 = 'primary.700';
export var PRIMARY800 = 'primary.800';
export var PRIMARY900 = 'primary.900';
export var PRIMARY950 = 'primary.950';
//success
export var SUCCESS25 = 'success.25';
export var SUCCESS50 = 'success.50';
export var SUCCESS100 = 'success.100';
export var SUCCESS200 = 'success.200';
export var SUCCESS300 = 'success.300';
export var SUCCESS400 = 'success.400';
export var SUCCESS500 = 'success.500';
export var SUCCESS600 = 'success.600';
export var SUCCESS700 = 'success.700';
export var SUCCESS800 = 'success.800';
export var SUCCESS900 = 'success.900';
export var SUCCESS950 = 'success.950';
//warning
export var WARNING25 = 'warning.25';
export var WARNING50 = 'warning.50';
export var WARNING100 = 'warning.100';
export var WARNING200 = 'warning.200';
export var WARNING300 = 'warning.300';
export var WARNING400 = 'warning.400';
export var WARNING500 = 'warning.500';
export var WARNING600 = 'warning.600';
export var WARNING700 = 'warning.700';
export var WARNING800 = 'warning.800';
export var WARNING900 = 'warning.900';
export var WARNING950 = 'warning.950';
//indigo
export var INDIGO200 = 'indigo.200';
//grayBlue
export var GRAYBLUE300 = 'grayBlue.300';